import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4912954a&scoped=true&"
import script from "./list.vue?vue&type=script&lang=ts&"
export * from "./list.vue?vue&type=script&lang=ts&"
import style0 from "./list.vue?vue&type=style&index=0&lang=stylus&module=true&"
import style1 from "./list.vue?vue&type=style&index=1&id=4912954a&lang=stylus&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4912954a",
  null
  
)

export default component.exports